import { HttpError } from '../common'; // Assuming HttpError is still here as per sessions-api-client.ts

export interface AuthTokenResponse {
    token: string;
}

export class InternalTokenApiClient {

    constructor(private readonly host: string) { }

    // todo: extract to common base REST client along with sessions-api-client.ts
    private async post(url: string, body: Record<string, any>): Promise<any> {
        const method = 'POST';
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await fetch(url, {
            method: method,
            headers: headers,
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new HttpError(`HTTP error - status: ${response.status}`);
        }
        return await response.json();
    }

    async createAuthToken(encodedSessionData: string): Promise<AuthTokenResponse> {
        const endpoint = 'auth-token';
        const response = await this.post(`${this.host}/${endpoint}`, { session_data: encodedSessionData });
        return response;
    }
}
